var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Category",
      prop: "category"
    }
  }, [_vm.formData.rangeId ? _c("el-tree", {
    ref: "tree",
    attrs: {
      "show-checkbox": "",
      "node-key": "id",
      "default-expanded-keys": _vm.expandedCategories,
      "default-checked-keys": _vm.selectedCategories,
      "filter-node-method": _vm.filterNode,
      "check-on-click-node": true,
      "empty-text": "No Categories",
      props: {
        label: "name",
        isLeaf: "leaf"
      },
      load: _vm.loadNode,
      lazy: ""
    },
    on: {
      "check-change": _vm.emitFormData
    }
  }) : _vm._e()], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };